// extracted by mini-css-extract-plugin
export default {"container":"styles_container__brnFP","title":"styles_title__oBnsj"};